<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useCompanyDetail } from "@/composables/models/company/useCompanyMe";
import { useAbility } from "@casl/vue";
import CompanyAddEditForm from "@/components/models/company/forms/CompanyAddEditForm.vue";
import { ECompanyType } from "@/api/models/company/company";

definePage({
  meta: {
    title: "generic.action.editEntity",
    titleParams: { entity: "generic.entity.gpCompany" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return (
        can($permActions.UPDATE, $permSubjects.PRACTICE__COMPANY) ||
        can($permActions.COMPANY_ME_EDIT, $permSubjects.PRACTICE__COMPANY)
      );
    },
  },
});

const route = useRoute();
const companyId = computed(() => (route.params as { id: string }).id);
const useMe = computed(() => route.query.scope === "me");
const { data: defaultValues, isLoading } = useCompanyDetail(
  { id: companyId },
  { useMe, redirectOnNotFound: true }
);

const type = computed(() =>
  defaultValues.value?.type === ECompanyType.GP_PRACTICES ? "gp" : "ortho"
);
</script>

<template>
  <v-skeleton-loader :loading="isLoading">
    <CompanyAddEditForm
      :defaultValues="defaultValues"
      :form-for-what-type="type"
    />
  </v-skeleton-loader>
</template>

<style scoped></style>
